// extracted by mini-css-extract-plugin
export default {"toggle":"c2A_dD04q","editCircle":"cdsDzQBKI","off":"cNhxX40GV","on":"cuWEgIaTk"};